import { useState, useMemo } from "react";
import { TableV2 as Table } from "@asayinc/component-library";
import { useGetTopShareholdersQuery } from "../../../../../store/allNetworkStats";
import { getColumnData, getRowData } from "./factories";
import { ROW_OPTIONS } from "../../../../../constants";
import { Loader } from "../../../../../components/Common";

const TopShareholdersTable = (): JSX.Element | null => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(ROW_OPTIONS[0].value);

  const {
    data: topShareholdersData,
    isLoading,
    isFetching,
    isError,
  } = useGetTopShareholdersQuery({ page: page });

  const rowData = useMemo(
    () => getRowData({ shareholders: topShareholdersData?.results || [] }),
    [topShareholdersData?.results]
  );

  const columnData = useMemo(() => getColumnData(), []);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleRowsChange = (rows: number) => {
    setRowsPerPage(rows);
    setPage(1);
  };

  if (isLoading && !topShareholdersData) {
    return <Loader />;
  }

  if (isError || !topShareholdersData || !topShareholdersData.results.length) {
    return null;
  }

  // Hardcode count to 100 since API doesn't return count field
  const count = 100;

  const paginateProps = {
    onChangePage: handlePageChange,
    onChangeRows: handleRowsChange,
    count,
    page: page,
    rowsPerPage: rowsPerPage,
    rowOptions: ROW_OPTIONS,
  };

  return (
    <Table
      title="Top Shareholders"
      tableMinWidth={800}
      testid="top-shareholders-table"
      columns={["name", "shares_owned", "shares_value", "location"]}
      columnData={columnData}
      rows={rowData}
      count={count}
      paginateProps={paginateProps}
      isLoading={isLoading}
      isFetching={isFetching}
      memoCells
    />
  );
};

export default TopShareholdersTable;
